import RoleManager from './RoleManager';

export default RoleManager;
